import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AdminInvitationsList } from '../components/AdminInvitationsList';
import type { ProjectsListColumn } from '../components/ProjectsListTable';
import { adminApi } from '../services/api';
import type { AdminCompanyInvitation } from '../types';

const DEFAULT_COLUMN_ORDER = [
  'customerName', 'companyName', 'contactEmail', 'contactPhone', 'status', 'createdAt'
];

export function AdminCompanyInvitationList() {
  const { t } = useTranslation();

  // Memoized: the shared list rebuilds its columns when these change.
  const ownColumns: ProjectsListColumn<AdminCompanyInvitation>[] = useMemo(() => [
    { field: 'customerName', label: t('adminCompanyInvitations.columns.customerName'), render: i => i.customerName },
    { field: 'companyName', label: t('adminCompanyInvitations.columns.companyName'), render: i => i.companyName }
  ], [t]);

  return (
    <AdminInvitationsList<AdminCompanyInvitation>
      i18nPrefix="adminCompanyInvitations"
      breadcrumb={[
        { label: t('nav.home'), path: '/admin/home' },
        { label: t('adminCompanyInvitations.title') }
      ]}
      load={adminApi.getAllCompanyInvitations}
      // Same saved preference key as before the shared table, so a saved order survives.
      preferenceKey="adminCompanyInvitationListColumns"
      defaultColumnOrder={DEFAULT_COLUMN_ORDER}
      ownColumns={ownColumns}
      nameSort={{ field: 'companyName', label: t('adminCompanyInvitations.sort.companyNameAZ') }}
      cardTitle={i => i.companyName}
      cardLines={i => i.customerName && (
        <div className="text-muted small"><i className="feather-user me-1"></i>{i.customerName}</div>
      )}
      exportName="company_invitations"
      testIds={{ table: 'admin-company-invitations-table', cards: 'admin-company-invitations-cards' }}
    />
  );
}
